import BasicModel from '../basic/BasicModel'
export default {
  findClue(vm, params, listener) {
    let action = 'clue/findClue.action'
    BasicModel.get(vm, action, params, listener)
  },
  editClueSettlement(vm, params, listener) {
    let action = 'clue/editClueSettlement.action'
    BasicModel.get(vm, action, params, listener)
  },
  getClueSettlement(vm, listener) {
    let action = 'clue/getClueSettlement.action'
    BasicModel.get(vm, action, null, listener)
  },
  setClueNote(vm, params, listener) {
    let action = 'clue/setClueNote.action'
    BasicModel.get(vm, action, params, listener)
  },
  findFormDatas(vm,params,listener){
    let action = 'clue/findFormDatas.action'
    BasicModel.get(vm, action, params, listener)
  },
  updateRemark(vm,params,listener){
    let action = 'clue/updateRemark.action'
    BasicModel.get(vm, action, params, listener)
  },
  setOneBuyCarClueNote(vm,params,listener){
    let action = 'clue/setOneBuyCarClueNote.action'
    BasicModel.get(vm, action, params, listener)
  },

  selectFormDataCounts(vm,params,listener){
    let action = 'clue/selectFormDataCounts.action'
    BasicModel.get(vm, action, params, listener)
  },
  findLcwClue(vm,params,listener){
    let action = 'clue/findLcwClue.action'
    BasicModel.get(vm, action, params, listener)
  },
  changeStatus(vm,params,listener){
    let action = 'clue/changeStatus.action'
    BasicModel.get(vm, action, params, listener)
  },
  saveRemark(vm,params,listener){
    let action = 'clue/saveRemark.action'
    BasicModel.get(vm, action, params, listener)
  }

}
